/* eslint-disable */
import React from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { QUERY_KEYS } from './DmtFino/DmtHooks/QueryKeys';
import { Dialog, DialogActions, DialogTitle, Slide, TextField, Box } from '@mui/material';
import Grid from '@mui/system/Unstable_Grid/Grid';
import { LoadingButton } from '@mui/lab';
import { handleCatchError } from 'utils/CatchHandler';
import { editCustomer } from 'utils/API/Merchant APIs/UpdatedAPIs/DMTUpdatedAPICalls';
import { globalNotifySuccess } from 'views/utilities/AlertToast';

const commonStyles = {
    m: 0
};
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});
const EditOptionComponent = ({ showEdit, custId, custName }) => {
    const queryClient = useQueryClient();
    const initialValues = {
        name: custName
    };
    const validationSchema = Yup.object({
        name: Yup.string()
            .required('Name is required')
            .matches(/^[a-zA-Z]+(?:-[a-zA-Z]+)*(?: [a-zA-Z]+(?:-[a-zA-Z]+)*)*$/, 'Please enter a valid name')
            .max(50, 'Name must be at most 50 characters')
    });

    const submitHandler = async (values, { setSubmitting: setIsLoading }) => {
        try {
            setIsLoading(true);
            const payload = {
                agentId: '2',
                customerName: values.name,
                custId
            };
            const response = await editCustomer(payload);
            if (response?.data?.success) {
                globalNotifySuccess(response?.data?.message);
            }
            showEdit(false);
            setIsLoading(false);
            queryClient.invalidateQueries(QUERY_KEYS.CUSTOMERS_LIST);
        } catch (error) {
            setIsLoading(false);
            handleCatchError(error);
        }
    };

    return (
        <>
            <Dialog
                open={showEdit}
                TransitionComponent={Transition}
                onClose={() => showEdit(false)}
                keepMounted
                aria-describedby="alert-dialog-slide-description"
                sx={{
                    '& .MuiDialog-paper': {
                        width: '100%',
                        maxWidth: '600px',
                        margin: '0 auto',
                        padding: { xs: '10px', sm: '20px' },
                        '@media (max-width: 600px)': {
                            width: '90%'
                        }
                    }
                }}
            >
                <DialogTitle>{'Enter your Full Name'}</DialogTitle>
                <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={submitHandler}>
                    {({ values, errors, touched, handleBlur, setFieldValue, isValid, isSubmitting }) => (
                        <Form>
                            <Box
                                sx={{
                                    width: '100%',
                                    height: 'auto',
                                    backgroundColor: '#fff',
                                    ...commonStyles,
                                    borderRadius: 2,
                                    marginBottom: 2,
                                    padding: { xs: '10px', sm: '20px' }
                                }}
                            >
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={12}>
                                        <TextField
                                            id="outlined-basic"
                                            label="Name"
                                            name="name"
                                            variant="outlined"
                                            fullWidth
                                            value={values.name}
                                            onChange={(e) => {
                                                let inputValue = e.target.value.replace(/[^a-zA-Z\s]/g, '');
                                                inputValue = inputValue.slice(0, 50);
                                                setFieldValue('name', inputValue);
                                            }}
                                            helperText={touched.name && errors.name}
                                            error={touched.name && Boolean(errors.name)}
                                            onBlur={handleBlur}
                                        />
                                    </Grid>
                                </Grid>
                                <DialogActions>
                                    <LoadingButton
                                        variant="contained"
                                        fullWidth
                                        disabled={isSubmitting || !values.name || !isValid}
                                        loading={isSubmitting}
                                        type="submit"
                                    >
                                        Submit
                                    </LoadingButton>
                                </DialogActions>
                            </Box>
                        </Form>
                    )}
                </Formik>
            </Dialog>
        </>
    );
};

export default EditOptionComponent;
